import loadable from '@loadable/component';
import { useMediaQuery, useTheme } from '@material-ui/core';
import React from 'react';
import { RIGHT_SIDEBAR_WIDTH } from 'src/constants';
import { useAppSelector } from 'src/hooks/useStore';

const PdfViewer = loadable(() => import('src/components/UI/PDFViewer'));
const maxPdfPageWidth = 600;
const mobilePreviewRightSpacing = 100;
export const NotificationPdfViewer: React.FC<{
  pdfUrl: string;
  previewContainerRef: React.RefObject<HTMLDivElement>;
}> = ({ pdfUrl, previewContainerRef }) => {
  const [pdfPageWidth, setPdfPageWidth] = React.useState<number>(0);
  const isTimelineShowing = useAppSelector(
    (state) => state.ui.rightSideBar.isOpen,
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  // this function handles getting the dynamically sized pdf page width.
  const setDynamicallyPdfPageWidth = () => {
    if (!previewContainerRef.current?.parentElement) return;
    const desktopPreviewRightSpacing = isTimelineShowing
      ? RIGHT_SIDEBAR_WIDTH
      : 0;
    const containerWidth =
      previewContainerRef.current.parentElement.clientWidth -
      (isMobile ? mobilePreviewRightSpacing : desktopPreviewRightSpacing);
    // we want to keep the pdf page width to a max of 800px
    // this way it does not get too big on large screens.
    setPdfPageWidth(
      containerWidth > maxPdfPageWidth ? maxPdfPageWidth : containerWidth,
    );
  };

  React.useEffect(() => {
    setDynamicallyPdfPageWidth();
    window.addEventListener('resize', setDynamicallyPdfPageWidth);
    return () => {
      window.removeEventListener('resize', setDynamicallyPdfPageWidth);
    };
  }, [isTimelineShowing, isMobile]);

  return <PdfViewer pdfPageWidth={pdfPageWidth} pdfUrl={pdfUrl} />;
};
